var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditorOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.182,
    height: 33.182,
    viewBox: "0 0 33.182 33.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.5 -1.318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,34.5H6A4.505,4.505,0,0,1,1.5,30V9A4.505,4.505,0,0,1,6,4.5H16.5a1.5,1.5,0,0,1,0,3H6A1.5,1.5,0,0,0,4.5,9V30A1.5,1.5,0,0,0,6,31.5H27A1.5,1.5,0,0,0,28.5,30V19.5a1.5,1.5,0,0,1,3,0V30A4.505,4.505,0,0,1,27,34.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,1.318a4.682,4.682,0,0,1,3.311,7.993l-14.25,14.25a1.5,1.5,0,0,1-.7.395l-6,1.5a1.5,1.5,0,0,1-1.819-1.819l1.5-6a1.5,1.5,0,0,1,.395-.7l14.25-14.25A4.651,4.651,0,0,1,30,1.318ZM17.233,21.146,31.189,7.189a1.682,1.682,0,0,0-2.379-2.379L14.854,18.767l-.793,3.172Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorOn);
export default __webpack_public_path__ + "static/media/Editor-On.4f8814bf84f76e2adbe8e7d736c01ec9.svg";
export { ForwardRef as ReactComponent };